// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2HbXn","title":"ClientReferral_title__2O7GT","itemText":"ClientReferral_itemText__2GgIi"};